import { Container, Flex, Grid, GridItem } from '@chakra-ui/react';

import { ExperienceImageTile, ExperiencesBox, Footer, HeroSection, StaysFilter, Visible } from 'components';
import { sampleHotels } from 'data';
import { Heading } from 'elements';
import { HotelFilters, useGetActivities, useSideScroll } from 'hooks';
import { HERO_IMG_URL } from 'data';

const Experiences = () => {
  const scrollRef = useSideScroll();

  const {data:responseData } = useGetActivities();

  const onSearch = (filters: HotelFilters) => {};

  return (
    <Visible when={true}>
      {/** hero section */}
      <Container maxW='container.xl'>
        <HeroSection
          filter={<StaysFilter onChange={onSearch} />}
          heading='One place, for everything'
          bgImage={HERO_IMG_URL.stays}
        />
      </Container>
      {/** hero section */}

      <Container maxW='container.xl' padding='1.5rem'>
        <Heading title='Selected for you' fontWeight={700} color="#1F1E1E"/>
      </Container>

      <Container ref={scrollRef as any} overflow='auto' maxW='container.xl'>
           <Flex flexDirection='row'>
                  {sampleHotels.map((hotel: any) => (
            <GridItem rowSpan={1} colSpan={1} key={hotel.id}>
              <ExperienceImageTile data={hotel} />
            </GridItem>
          ))}
            </Flex> 
      </Container>

      <Container maxW='container.xl' padding='1.5rem'>
        <Heading title='Mostly booked near you' fontWeight={700} color="#1F1E1E"/>
      </Container>

      <Container maxW='container.xl'>
        <Grid templateColumns='repeat(auto-fit, minmax(250px, 1fr))' gap={6} justifyItems='center'>
          {responseData?.data.map((activity: any) => (
            <GridItem rowSpan={2} colSpan={1} key={activity.id}>
              <ExperiencesBox data={activity} />
            </GridItem>
          ))}
        </Grid>
      </Container>
      <Footer />
    </Visible>
  );
};

export { Experiences };
